var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as lodash from '../../utils/lodash';
import { ComponentModel } from '../../model';
import { Rect } from '../../element';
import { registerComponent } from '../index';
/**
 * default class
 */
var Brush = /** @class */ (function (_super) {
    __extends(Brush, _super);
    function Brush() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'brush';
        _this._zoomRect = new Rect({ display: false });
        _this._dragging = false;
        _this.handlePlotDragStart = function () {
            if (!_this.option.enabled) {
                return;
            }
            _this._dragging = true;
            _this.chart.dispatchAction({
                type: 'brushstart',
            });
            _this._toogleTooltipDisabled(true);
            _this._zoomRect.setAttr({
                display: true,
                width: 0,
                height: 0,
            });
        };
        _this.handlePlotDrag = function (event) {
            if (!_this.option.enabled) {
                return;
            }
            var grid = _this.chart.getComponentModel('coord').grid;
            var axis = _this.option.axis;
            var _a = event.mouse, startX = _a.startX, startY = _a.startY, offsetX = _a.offsetX, offsetY = _a.offsetY;
            if (!_this._dragging && Math.abs(axis === 'x' ? offsetX : offsetY) > 10) {
                _this.handlePlotDragStart();
                return;
            }
            var _b = grid.getState(), gridTop = _b.top, gridLeft = _b.left, gridRight = _b.right, gridBottom = _b.bottom, width = _b.width, height = _b.height;
            var clampX = lodash.clamp(Math.min(startX, startX + offsetX), gridLeft, gridRight);
            var clampY = lodash.clamp(Math.min(startY, startY + offsetY), gridTop, gridBottom);
            var clampWidth = Math.min(width, Math.abs(offsetX));
            var clampHeight = Math.min(height, Math.abs(offsetY));
            if (axis === 'x') {
                _this._zoomRect.setAttr({
                    x: clampX,
                    y: gridTop,
                    width: clampWidth,
                    height: height,
                });
            }
            else if (axis === 'xy') {
                _this._zoomRect.setAttr({
                    x: clampX,
                    y: clampY,
                    width: clampWidth,
                    height: clampHeight,
                });
            }
            else if (axis === 'y') {
                _this._zoomRect.setAttr({
                    x: gridLeft,
                    y: clampY,
                    width: width,
                    height: clampHeight,
                });
            }
        };
        _this.handlePlotDragEnd = function (event) {
            if (!_this.option.enabled || !_this._dragging) {
                return;
            }
            _this._dragging = false;
            var _a = event.mouse, startX = _a.startX, startY = _a.startY, offsetX = _a.offsetX, offsetY = _a.offsetY;
            var grid = _this.chart.getComponentModel('coord').grid;
            var _b = grid.getState(), left = _b.left, right = _b.right, top = _b.top, bottom = _b.bottom;
            var xAxisList = grid.xAxis;
            var yAxisList = grid.yAxis;
            var axis = _this.option.axis;
            _this._zoomRect.setAttr({
                display: false,
            });
            var xAxisRange;
            var yAxisRange;
            if (axis === 'x' || axis === 'xy') {
                var start_1 = lodash.clamp(startX, left, right);
                var end_1 = lodash.clamp(startX + offsetX, left, right);
                xAxisList.forEach(function (xAxis) {
                    var startValue = xAxis.scale.invert(start_1);
                    var endValue = xAxis.scale.invert(end_1);
                    xAxis.option.min = lodash.min([startValue, endValue]);
                    xAxis.option.max = lodash.max([startValue, endValue]);
                    xAxisRange = [xAxis.option.min, xAxis.option.max];
                });
            }
            if (axis === 'y' || axis === 'xy') {
                var start_2 = lodash.clamp(startY, top, bottom);
                var end_2 = lodash.clamp(startY + offsetY, top, bottom);
                yAxisList.forEach(function (yAxis) {
                    var startValue = yAxis.scale.invert(start_2);
                    var endValue = yAxis.scale.invert(end_2);
                    yAxis.option.min = lodash.min([startValue, endValue]);
                    yAxis.option.max = lodash.max([startValue, endValue]);
                    yAxisRange = [yAxis.option.min, yAxis.option.max];
                });
            }
            _this._toogleTooltipDisabled(false);
            _this.chart.refresh();
            _this.chart.dispatchAction({
                type: 'brushend',
                xAxis: xAxisRange,
                yAxis: yAxisRange,
            });
        };
        return _this;
    }
    Brush.prototype.getDefaultOption = function () {
        return {
            enabled: false,
            axis: 'x',
            series: 'all',
            xAxis: [0],
            yAxis: [0],
            brushStyle: {
                lineWidth: 0,
                stroke: null,
                fill: '#F0F2F6',
                opacity: 0.5,
            },
        };
    };
    Brush.prototype.init = function () {
        this.registerEvent('plot:drag', this.handlePlotDrag);
        this.registerEvent('plot:dragend', this.handlePlotDragEnd);
    };
    Brush.prototype.beforeDestroy = function () {
        // todo;
    };
    Brush.prototype.update = function (option, mergeOld) {
        _super.prototype.update.call(this, option, mergeOld);
        this.init();
    };
    Brush.prototype.render = function () {
        return this._zoomRect.setAttr(__assign({ key: this.getKey('zoom-rect') }, this.getShapeStyle(this.option.brushStyle)));
    };
    Brush.prototype._toogleTooltipDisabled = function (disabled) {
        var tooltip = this.chart.getComponentModel('tooltip');
        if (tooltip) {
            tooltip.disabled = disabled;
            disabled && tooltip.hideTooltip();
        }
    };
    return Brush;
}(ComponentModel));
export default Brush;
registerComponent('brush', Brush);
